<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <SearchSaHistoryForm
          :propsSaNo="saNo"
          :propsPartCd="partCd"
          :propsInspClassCd="inspClassCd"
          :propsSaExpiringSoon="saExpiringSoon"
          :propsIsWaiting="isWaiting"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SearchSaHistoryForm from '@/components/organisms/terminal/form/SearchSaHistoryForm'

export default {
  name: 'SearchSaHistoryPage',

  components: { SearchSaHistoryForm },

  data() {
    return {
      saNo: '',
      partCd: '',
      inspClassCd: '',
      saExpiringSoon: false,
      isWaiting: false,
    }
  },

  created() {
    const query = this.$route.query
    if (query.saNo) {
      this.saNo = query.saNo
    }
    if (query.partCd) {
      this.partCd = query.partCd
    }
    if (query.inspClassCd) {
      this.inspClassCd = query.inspClassCd
    }
    if (query.saExpiringSoon) {
      this.saExpiringSoon = this.$route.query.saExpiringSoon.toString().toLowerCase() === 'true'
    }
    if (query.isWaiting) {
      this.isWaiting = this.$route.query.isWaiting.toString().toLowerCase() === 'true'
    }
  },
}
</script>
